import { render, staticRenderFns } from "./AutoCompletar.vue?vue&type=template&id=3a2747d2&"
import script from "./AutoCompletar.vue?vue&type=script&lang=js&"
export * from "./AutoCompletar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports